import { breakpoints, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const LoadingContainer = styled.div `
  display: flex;
  padding: ${theme.spacing.xl};
  align-items: center;
  justify-content: center;
`;
export const PaginationContainer = styled.div `
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: center;
  padding: ${theme.spacing['2xl']} 0;

  ${breakpoints.md} {
    justify-content: flex-start;
  }
`;
